import { Link } from '@idexx-laboratories/spot-react';
import React from 'react';

export const MessageWithPracticeAdmin = (): React.JSX.Element => (
  <>
    <p>We see that you do not have permissions to access this task.</p>
    <p>Please contact your Practice Admin to continue.</p>
  </>
);

export const MessageWithoutPracticeAdmin = (): React.JSX.Element => (
  <>
    <p>Your practice must have at least one administrative user to access the task.</p>
    <p>Click the User Management card to create your first practice admin.</p>
  </>
);

export const MessageSupportAssistanceRequired = (): React.JSX.Element => (
  <>
    <p>
      Your Cornerstone configuration requires a Cornerstone support technician to create your first
      practice admin user.
    </p>
    <p>
      Please contact Cornerstone Support at <strong>1-800-695-2877</strong> to continue.
    </p>
  </>
);

export const MessageSendVerificationCode = (props: { practiceName: string }): React.JSX.Element => (
  <>
    <p>
      To verify your affiliation with <strong>{props.practiceName}</strong>, a 6 digit code will be
      sent to your Cornerstone server.
    </p>
    <p>
      The code will be saved to the desktop in a text file named{' '}
      <strong>MyCornerstone Verification Code</strong>.
    </p>
    <p>
      Open the file to retrieve the code and enter it here. The code will expire{' '}
      <strong>10 minutes</strong> after it is sent.
    </p>
  </>
);

export const MessageServerOffline = (): React.JSX.Element => (
  <>
    <p>It looks like your Cornerstone Server is off or not connected to the Internet.</p>
    <p>
      Ensure it is on and connected before continuing, or contact Cornerstone Support at{' '}
      <strong>1-800-695-2877</strong> for assistance.
    </p>
  </>
);

export const MessageMultipleServers = (): React.JSX.Element => (
  <>
    <p>It looks like more than one computer was configured as a Cornerstone server recently.</p>
    <p>
      Please contact Cornerstone Support at <strong>1-800-695-2877</strong> to identify your true
      server before continuing.
    </p>
  </>
);

export const MessageNoServer = (): React.JSX.Element => (
  <>
    <p>It looks like we cannot identify your Cornerstone server.</p>
    <p>
      Please contact Cornerstone Support at <strong>1-800-695-2877</strong> to identify your server
      before continuing.
    </p>
  </>
);

export const MessagePracticeUpgradeLocked = (props: {
  userName: string | undefined;
}): React.JSX.Element => (
  <>
    <p>
      <strong>{props.userName}</strong> is working on the upgrade task.
    </p>
    <p>Please try again once their session ends.</p>
  </>
);

export const MessageServerStatusUnavailable = (): React.JSX.Element => (
  <>
    <p>We see you had an upgrade scheduled, but cannot determine if it was completed.</p>
    <p>
      Please make sure your Cornerstone server is on and connected to the internet and try again.
    </p>
  </>
);

export const MessageNoUpgradeRequired = (): React.JSX.Element => (
  <>
    <p>It looks like your Cornerstone server already has the latest version installed.</p>
    <p>If you have any workstations which need to be upgraded, they must be upgraded manually.</p>
  </>
);

export const VelloIntegrationUnavailable = (): React.JSX.Element => (
  <>
    <p>Vello can only be administered by users with admin permissions within MyIDEXX.</p>
    <p>
      To access this integration, please ensure you are logged in as a MyIDEXX user with appropriate
      permissions.
    </p>
  </>
);

export const MessageNoSupportContact = (): React.JSX.Element => (
  <>
    <p>According to our records, your practice&apos;s support contract is not current.</p>
    <p>
      Please call <strong>1-800-283-8386</strong> to discuss your support options.
    </p>
  </>
);

export const MessageSupportStatusUnknown = (): React.JSX.Element => (
  <>
    <p>We were unable to determine if your practice has an active Cornerstone support contract.</p>
    <p>Please try again later.</p>
  </>
);

export const MessageCorrectVelloPractice = (): React.JSX.Element => (
  <>
    <p>Please verify that you are viewing the correct practice in Vello.</p>
    <p>If not, contact Cornerstone Support.</p>
  </>
);

export const MessageAccountBlocked = (): React.JSX.Element => (
  <>
    <p>
      For security or policy reasons, your account is currently inactivated and access has been
      disabled.
    </p>
    <p>
      Please contact Cornerstone support at <Link href='tel:18006952877'>1-800-695-2877</Link> for
      further assistance.
    </p>
  </>
);
